export const ContractType = [
  { value: "", label: "Select contract type" },
  { value: "FullTime", label: "Full Time" },
  { value: "FullTime09001800", label: "Full Time 09:00 - 18:00" },
  { value: "FullTime14002300", label: "Full Time 14:00 - 23:00" },
  { value: "FullTime15000000", label: "Full Time 15:00 - 00:00" },
  { value: "FullTime15300030", label: "Full Time 15:30 - 00:30" },
  { value: "FullTime16000100", label: "Full Time 16:00 - 01:00" },
  { value: "FullTime00000800", label: "Full Time 00:00 - 08:00" },
  { value: "PartTime", label: "Part Time" },
  { value: "PartTime08001600", label: "Part Time 08:00 - 16:00" },
  { value: "PartTime10001800", label: "Part Time 10:00 - 18:00" },
  { value: "PartTime12002000", label: "Part Time 12:00 - 20:00" },
  { value: "PartTime14002000", label: "Part Time 14:00 - 20:00" },
  { value: "PartTime14002200", label: "Part Time 14:00 - 22:00" },
  { value: "PartTime15002200", label: "Part Time 15:00 - 22:00" },
  { value: "PartTime16000000", label: "Part Time 16:00 - 00:00" },
  {
    value: "WeekendPartTime08002000",
    label: "Weekend Part Time 08:00 - 20:00",
  },
  {
    value: "WeekendPartTime20000800",
    label: "Weekend Part Time 20:00 - 08:00",
  },
  { value: "W2", label: "W2" },
  { value: "F1099", label: "1099" },
  { value: "Freelancer", label: "Freelancer" },
];

export const contractTypeLabels: Record<string, string> = {
  fullTime: "Full Time",
  fullTime09001800: "Full Time 09:00 - 18:00",
  fullTime14002300: "Full Time 14:00 - 23:00",
  fullTime15000000: "Full Time 15:00 - 00:00",
  fullTime15300030: "Full Time 15:30 - 00:30",
  fullTime16000100: "Full Time 16:00 - 01:00",
  fullTime00000800: "Full Time 00:00 - 08:00",
  partTime: "Part Time",
  partTime08001600: "Part Time 08:00 - 16:00",
  partTime10001800: "Part Time 10:00 - 18:00",
  partTime12002000: "Part Time 12:00 - 20:00",
  partTime14002000: "Part Time 14:00 - 20:00",
  partTime14002200: "Part Time 14:00 - 22:00",
  partTime15002200: "Part Time 15:00 - 22:00",
  partTime16000000: "Part Time 16:00 - 00:00",
  partTime08002000: "Part Time 08:00 - 20:00",
  partTime20000800: "Part Time 20:00 - 08:00",
  weekendPartTime08002000: "Weekend Part Time 08:00 - 20:00",
  weekendPartTime20000800: "Weekend Part Time 20:00 - 08:00",
  w2: "W2",
  f1099: "1099",
  freelancer: "Freelancer",
};
